import { GET_MONTHLY_SALES_PROMOTION_CONTRACTS_INFO,
  GET_YEARLY_SALES_PROMOTION_CONTRACTS_INFO} from '../actions';
  
  const initialState = {
    contractsMonthlySalesData:null, 
  };  
  // Reducer
  function SalesDashBoardReducer(state = initialState, action) {
    let contractsMonthlySalesData,contractsYearlySalesData;     
    switch (action.type) {    
      case `${GET_MONTHLY_SALES_PROMOTION_CONTRACTS_INFO}_FULFILLED`:
          contractsMonthlySalesData = action.payload.data;
          return { ...state, loading: false, contractsMonthlySalesData }; 
      case `${GET_YEARLY_SALES_PROMOTION_CONTRACTS_INFO}_FULFILLED`:
          contractsYearlySalesData = action.payload.data;
          return { ...state, loading: false, contractsYearlySalesData };
      case `${GET_MONTHLY_SALES_PROMOTION_CONTRACTS_INFO}_REJECTED`:
          return { ...state, loading: false,  contractsMonthlySalesDataError: `${action.payload.message}`, state: initialState };  
      case `${GET_YEARLY_SALES_PROMOTION_CONTRACTS_INFO}_REJECTED`:
          return { ...state, loading: false,  contractsYearlySalesDataError: `${action.payload.message}`, state: initialState };
      default:
        return state;
    }
  }  
  export default SalesDashBoardReducer;
  
  